import * as React from "react";
const SvgFiRrHouseTree = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-tree_svg__a)">
      <path
        fill="#062147"
        d="M23.604 22.253A3.3 3.3 0 0 1 20.687 24H18a1 1 0 1 1 0-2h2.687c.491 0 .922-.26 1.154-.692a1.29 1.29 0 0 0-.065-1.343 1 1 0 0 1-.057-.098l-2.274-4.41A1 1 0 0 1 20.334 14h.404a.2.2 0 0 0 .186-.11.2.2 0 0 0-.011-.217l-2.794-5.2A1.002 1.002 0 0 1 19 7a.2.2 0 0 0 .185-.11.2.2 0 0 0 .012-.177l-3.991-4.657c-.087-.08-.28-.133-.463.053l-3.05 3.545a1 1 0 0 1-1.516-1.305L13.275.752c.987-1.006 2.509-.955 3.402-.051 0 0 4.157 4.85 4.181 4.889a2.21 2.21 0 0 1-.455 2.908l2.224 4.146c.404.598.446 1.467.061 2.188-.202.377-.502.68-.86.881l1.646 3.193a3.3 3.3 0 0 1 .13 3.347M16 15.348V19.5c0 2.48-2.019 4.5-4.5 4.5h-7A4.505 4.505 0 0 1 0 19.5v-4.152c0-1.549.699-2.982 1.918-3.939l3-2.347a4.99 4.99 0 0 1 6.163 0l3 2.349a4.97 4.97 0 0 1 1.918 3.938zm-2 0c0-.93-.419-1.79-1.151-2.363l-3-2.348a2.99 2.99 0 0 0-3.698.001l-3 2.347A2.99 2.99 0 0 0 2 15.348V19.5C2 20.878 3.122 22 4.5 22h7c1.378 0 2.5-1.122 2.5-2.5zm-5-.349H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-tree_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseTree;
